<template>
  <div class="form-group text-style-buttons">
    <label v-if="labelDesc && (labelDesc.indexOf('ct-') < 0)">{{ labelDesc }}</label>
    <div class="form" v-show="!showSizeMobile">

        <label>{{$t('ct-font-style')}}</label>
        <div class="font-style-container">
          <input type="number" class="custom-number form-control font-size" min="10" max="120" step="1"
                 @change="changeValue"
                 v-model="size">
          <color-picker-component ref="colorPicker" class="font-color"></color-picker-component>
        </div>
        <select name="fontFamily" v-model="family"
                class="form-control w-100 font-family"
                @change="changeValue">
          <option v-for="(family, idx) in listFont" v-bind:value="family.value" :key="idx">{{family.text}}</option>
        </select>
        <div class="font-style-container" >
          <div class="btn-group btn-group-sm" role="group" aria-label="Basic example"
               style="width: 250px;">
            <button @click="changeFuckingStyle" class="btn btn-outline-info btn-small">B</button>
            <button @click="changeFuckingItalicStyle" class="btn btn-outline-info btn-small">I</button>

            <div v-show="element !== 'option-button'">
                <button type="button" class="btn btn-outline-info btn-small" value="left"
                    @click="changeAlign('left')">
              <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-left']"
                                 @click="changeAlign('left')"/>
            </button>
              <button type="button" class="btn btn-outline-info btn-small" value="center"
                      @click="changeAlign('center')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-center']"
                                  @click="changeAlign('center')"/>
              </button>
              <button type="button" class="btn btn-outline-info btn-small" value="right"
                      @click="changeAlign('right')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-right']"
                                  @click="changeAlign('right')"/>
              </button>
              <button type="button" class="btn btn-outline-info btn-small" value="justify"
                      @click="changeAlign('justify')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-justify']"
                                  @click="changeAlign('justify')"/>
              </button>
            </div>
          </div>
        </div>

    </div>
    <div v-show="showSizeMobile">
      <div class="font-style-container" style="display: block">
        <label class="w-100">
          {{$t('ct-font-style-family')}}
          <select name="fontFamily" v-model="family"
                  class="form-control"
                  @change="changeValue">
            <option v-for="(family, idx) in listFont" v-bind:value="family.value" :key="idx">{{family.text}}</option>
          </select>
        </label>
        <label class="w-100">
          {{$t('ct-font-style-size')}}
          <input type="number" class="custom-number form-control" min="10" max="120" step="1"
                 @change="changeValue"
                 v-model="size">
        </label>
        <label class="w-100">
          {{$t('ct-font-style-size-mobile')}}
          <input type="number" class="custom-number form-control" min="10" max="120" step="1"
                 @change="changeValue"
                 v-model="sizeMobile">
        </label>
        <label class="w-100">
          {{$t('ct-font-style-color')}}
          <color-picker-component ref="colorPickerMobile"></color-picker-component>
        </label>
      </div>
      <div class="font-style-container">
        <div class="btn-group btn-group-sm" role="group" aria-label="Basic example"
             style="width: 250px;">
          <button @click="changeFuckingStyle" class="btn btn-outline-info btn-small">B</button>
          <button @click="changeFuckingItalicStyle" class="btn btn-outline-info btn-small">I</button>
          <button type="button" class="btn btn-outline-info btn-small" value="left"
                  @click="changeAlign('left')">
            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-left']"
                               @click="changeAlign('left')"/>
          </button>
          <button type="button" class="btn btn-outline-info btn-small" value="center"
                  @click="changeAlign('center')">
            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-center']"
                               @click="changeAlign('center')"/>
          </button>
          <button type="button" class="btn btn-outline-info btn-small" value="right"
                  @click="changeAlign('right')">
            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-right']"
                               @click="changeAlign('right')"/>
          </button>
          <button type="button" class="btn btn-outline-info btn-small" value="justify"
                  @click="changeAlign('justify')">
            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'align-justify']"
                               @click="changeAlign('justify')"/>
          </button>
        </div>
      </div>
    </div>

    <div class="font-style-container" v-show="shitOptions">

      <label class="w-100">
        {{$t('ct-text-decoration')}}
        <select v-model="stroke" class="form-control" @change="putThisShitOnButton">
          <option value="none"> {{$t('ct-none')}}</option>
          <option value="overline"> {{$t('ct-overline')}}</option>
          <option value="line-through"> {{$t('ct-line-through')}}</option>
          <option value="underline"> {{$t('ct-underline')}}</option>
        </select>
      </label>
    </div>
  </div>
</template>

<script>

	import ColorPickerComponent from "./Abstract/ColorPicker";
	import FontGroupEdition from "../base/sidebar/FontGroupEdition";

	export default {
		name: 'TextStyleComponent',
		components: {
			FontGroupEdition,
			ColorPickerComponent,
		},
		props: ['type', 'name'],
		data() {
			return {
				element: null,
				family: null,
				size: null,
				sizeMobile: null,
				shitOptions: false,
				showSizeMobile: false,
				color: null,
				align: null,
				weight: null,
				style: null,
				stroke: null,
				callback: null,
				listFont: FontGroupEdition.data().options,
				labelDesc: '',
			}
		},
		methods: {
			changeFuckingStyle() {
				this.weight = this.weight === 700 ? 400 : 700;
          if(this.element === 'option' || this.element === 'option-button') { this.callback(this.$data) } else { this.callback(); }
			},
			changeFuckingItalicStyle() {
				this.style = this.style === 'italic' ? 'initial' : 'italic';
				  if(this.element === 'option' || this.element === 'option-button') { this.callback(this.$data) } else { this.callback(); }
			},
			putThisShitOnButton() {
				  if(this.element === 'option' || this.element === 'option-button') { this.callback(this.$data) } else { this.callback(); }

			},
			changeAlign(val) {
				this.align = val;
				  if(this.element === 'option' || this.element === 'option-button') { this.callback(this.$data) } else { this.callback(); }

			},
			changeValue() {
				  if(this.element === 'option' || this.element === 'option-button') { this.callback(this.$data) } else { this.callback(); }
			},
			setValues(obj, elem) {
				this.element = elem;

				this.showSizeMobile = obj.showSizeMobile ? obj.showSizeMobile : false;
				this.shitOptions = obj.shitOptions ? obj.shitOptions : false;

				this.family = obj.defaultFamily;
				this.size = parseInt(obj.defaultSize);
				this.sizeMobile = parseInt(obj.defaultSizeMobile);
				this.color = obj.defaultColor;
				this.align = obj.defaultAlign;
				this.weight = obj.defaultWeight;
				this.style = obj.defaultStyle;
				this.stroke = obj.defaultStroke;
				this.callback = obj.callback;
				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);

				let vm = this;

				let newObj = Object.assign({}, obj);
				newObj.defaultValue = obj.defaultColor;
				newObj.callback = (value) => {
					vm.color = value;
					vm.changeValue()
				};
				this.$refs.colorPicker.setValues(newObj);
				this.$refs.colorPickerMobile.setValues(newObj);
			}
		},
		mounted() {
			let vm = this;
			this.$root.$on('setFontStyleFonts', (data) => {
				vm.listFont = data;
			});
		}
	}

</script>

<style scoped lang="scss">
  .radio {
    display: inline-grid;
    margin-left: 5px;
    width: 100%;
  }

  .form-group {
    /*overflow: hidden;*/
  }

  .font-style-container {
    display: flex;
    margin-top: 5px;

    .font-awesome-icon {
      vertical-align: middle;
    }
  }
  .styleElementBoxShadow .custom-range {
    width: 100%;
  }
</style>

<style lang="scss">
  .font-size {
    border-right: 0;
    border-bottom: 0;
    width: 50%;
    border-radius: 4px 0px 0px 0px;
    &:focus {
      box-shadow: none;
    }
  }
  .font-color {
    border-left: 0;
    border-bottom: 0;
    width: 50% !important;
    & .current-color {
          border-radius: 0px 4px 0px 0px !important;
          border-bottom: 0 !important;
    }
    &:focus {
      box-shadow: none;
    }
  }
  .font-family {
    width: 100%;
    border-radius: 0px 0px 4px 4px;

    &:focus {
      box-shadow: none;
    }

  }
  .font-color .vc-sketch {
    min-width: 185px;
    max-width: 185px;
    margin-left: -100%;
  }

  .text-style-buttons .btn-outline-info {
    min-width: 35px;
    padding: .375rem;
    max-width: 35px;
    font-size: 12px;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/resources/TextStyle.vue